<script lang="ts">
  import type { Endpoint } from "../interfaces/endpoint";
  import type { ChildGroup } from "../interfaces/explore";
  import { approveOrigin, requestOrigin } from "../services/api";
  import { createObjectMap, getCamelCaseBreakString, getSlashBreakString } from "../services/shared";
  import { endpointConfig } from "../../public/configuration";
  import InnerHtml from "./inner-html.svelte";
  import PropertyValue from "./property-value.svelte";

  export let group: ChildGroup | null = null;
  let _endpoint: Endpoint | null = null;
  export let endpoint: Endpoint | null = null;
  $: {
    if (endpoint && _endpoint?.request.name !== endpoint.request.name) {
      createObjectMap('', [], endpoint, endpointObjectMap);
      endpointObjectMap = { ...endpointObjectMap };
      _endpoint = endpoint;
    }
  }

  let configuration = endpointConfig;
  let endpointObjectMap = {};

  const requestKey = 'request';
  const responseKey = 'response';
  const visibleRequestKeys = ['headers', 'parameters'];
  const visibleResponseKeys = ['success'];
</script>

<div class="endpoint">
  <div class="endpoint__header">
    <h2><InnerHtml htmlType="span" text={getCamelCaseBreakString(group.name)} /></h2>
    {#if group.links[0]?.link}<InnerHtml text={getSlashBreakString(requestOrigin === approveOrigin ? group.links[0].link.replace(approveOrigin, '') : group.links[0].link)} />{/if}
    {#if group.description}<div><InnerHtml htmlType="span" text={group.description} /></div>{/if}
  </div>
  {#if endpoint}
    <!-- TODO split endpoint__body in two flex sections and build recursive list component to visualize json request and response examples -->
    <div class="endpoint__body">
      <div class="endpoint__body__side">
        {#if endpoint}
          {#each Object.entries(endpoint) as [parentKey, parentValue]}
            {#each Object.entries(parentValue) as [key, value]}
              {#if [...visibleRequestKeys, ...visibleResponseKeys].includes(key) && value['properties']}
                <div class="endpoint__body__side__section">
                  <h4>
                    <span>{#if parentKey === requestKey}request{:else}{#if parentKey === responseKey}response{/if}{/if}</span>
                    <span style="color: var(--{key === 'errors' ? 'error' : key}-600)">{key}</span>
                  </h4>
                  <PropertyValue
                    {configuration}
                    objectMap={endpointObjectMap}
                    key={key}
                    value={value}
                    parentKey={parentKey}
                    parentValue={parentValue}
                  />
                </div>
              {/if}
            {/each}
          {/each}
        {/if}
      </div>
    </div>
  {/if}
</div>
